import { Box } from '@mui/material';

import { EVENT_AVAILABILITY, EVENT_COLORS } from './constants';
import { getAvailabilityLabel } from './helpers';

const BADGE_COLORS = Object.freeze({
  [EVENT_AVAILABILITY.OPEN]: EVENT_COLORS.good,
  [EVENT_AVAILABILITY.FULL_WAITLIST]: EVENT_COLORS.warn,
  [EVENT_AVAILABILITY.FULL]: EVENT_COLORS.danger,
  [EVENT_AVAILABILITY.CLOSED]: EVENT_COLORS.muted,
  [EVENT_AVAILABILITY.CANCELLED]: EVENT_COLORS.danger,
  [EVENT_AVAILABILITY.STARTED]: EVENT_COLORS.muted,
});

const EventBadge = ({ availability }) => {
  const color = BADGE_COLORS[availability] || EVENT_COLORS.muted;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 1.25,
        py: 0.25,
        borderRadius: '12px',
        border: `1px solid ${color}`,
        color,
        fontSize: 12,
        fontWeight: 700,
        whiteSpace: 'nowrap',
      }}
    >
      {getAvailabilityLabel(availability)}
    </Box>
  );
};

export default EventBadge;
